module.exports = __webpack_public_path__ + "07_mustache_grey.c871c0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/07_mustache_grey.png
// module id = KAkA
// module chunks = 0